
import React from "react";
import { DatePicker } from "../common/DatePicker";

interface DateFieldProps {
  label?: string;
  value: Date | null;
  onChange: (date: Date | null) => void;
  required?: boolean;
  minDate?: Date;
  maxDate?: Date;
  disabled?: boolean;
  helperText?: string;
  errorText?: string;
}

export const DateField: React.FC<DateFieldProps> = ({
  label,
  value,
  onChange,
  required,
  minDate,
  maxDate,
  disabled,
  helperText,
  errorText
}) => {
  return (
    <div className="field">
      {label && (
        <label className="label">
          {label}
          {required && <span style={{ color: "var(--danger)", marginLeft: 2 }}>*</span>}
        </label>
      )}
      <DatePicker 
        value={value} 
        onChange={onChange}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
      />
      {errorText && <div style={{ fontSize: 12, color: "var(--danger)", marginTop: 4 }}>{errorText}</div>}
      {helperText && !errorText && <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 4 }}>{helperText}</div>}
    </div>
  );
};
